import { useRubricTableColumns } from 'components/Rubrics/Table';
import { useApp } from 'contexts/app';
import { createContext, useMemo, useState } from 'react';
import { useTableSortableHeaderCellEffectHandlers } from 'shell/components';

const PageContext = createContext();

const handleFilters = (allData, filters, setSortedFilteredData) => {
    let res = [...allData];

    res = res?.filter((rubric) => {
        return rubric.rubric.title.toLowerCase().includes(filters.search.toLowerCase());
    });

    setSortedFilteredData(res);
};

const PageProvider = (props) => {
    const { rubrics, setRubrics } = useApp();
    const columns = useRubricTableColumns();

    const [filters, setFilters] = useState({
        open: false,
        search: '',
    });

    // memoize to not trigger re-render
    const allRubrics = useMemo(() => {
        return rubrics;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(rubrics ? rubrics : []).map((r) => r.id).join('.')]);

    const {
        sortedFilteredData: sortedFilteredRubrics,
        sortState,
        handleSetSortState,
    } = useTableSortableHeaderCellEffectHandlers(allRubrics, columns, filters, setRubrics, handleFilters, null);

    const resetFilters = () => {
        handleSetSortState({
            orderBy: null,
            order: 'asc',
        });
    };

    return (
        <PageContext.Provider
            value={{
                filters,
                setFilters,
                resetFilters,
                rubrics,
                setRubrics,
                sortedFilteredRubrics,
                sortState,
                handleSetSortState,
                columns,
            }}
            {...props}
        />
    );
};

export { PageContext };
export default PageProvider;
